import { forwardRef } from 'react';
import { NumericFormatProps, NumericFormat } from 'react-number-format';
import { NumericMaskProps } from './NumericMask.types';

export const NumericMask = forwardRef<NumericFormatProps, NumericMaskProps>(({ onChange, ...props }, ref) => {
    return (
        <NumericFormat
            {...props}
            allowNegative={false}
            decimalScale={0}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({ target: { value: values.value } });
            }}
        />
    );
});